import { actualAttributes, actualAttributesT } from './../../utils/constants';
import { TYPE_REDUCER } from '../../utils/constants';
import priceId from '../../../products.json';
import priceAdditional from '../../../productsAdditional.json';
export type modalName =
  | 'arStep1'
  | 'itemHint'
  | 'MailComponent'
  | 'MailSent'
  | 'loader';
export type modalListT = Record<modalName, boolean>;

export type initialStateT = {
  configInfo: {
    isShortId: boolean;
  };
  modalState: {
    modalInfo: null;
    modalList: modalListT;
  };
  attributes: {};
  priceInfo: {};
  priceAdditional: {};
};

// Mock initial attributes structure for UI display
const mockInitialAttributes = {
  'Jeep Type': {
    activeItem: '4 Door',
    defaultItem: '4 Door',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Paint color': {
    activeItem: 'Green',
    defaultItem: 'Green',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Wheels': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 2,
    price: 199.99,
    activeItemId: '14426',
    shopInfo: { quantity: 4 }
  },
  'Tire': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 1,
    price: 542.69,
    activeItemId: '20469',
    shopInfo: { quantity: 4 }
  },
  'Front Bumper': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 0,
    price: 499.99,
    activeItemId: '13763',
    shopInfo: { quantity: 1 }
  },
  'Rear Bumper': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 4,
    price: 499.99,
    activeItemId: '13765',
    shopInfo: { quantity: 1 }
  },
  'Front Fender': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 0,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Rear Fender': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: 4,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Door': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Mirror': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 2 }
  },
  'Hood Catcher': {
    activeItem: 'Default',
    defaultItem: 'Default',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 2 }
  },
  'Light Bar': {
    activeItem: 'None',
    defaultItem: 'None',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 1 }
  },
  'Side Steps': {
    activeItem: 'None',
    defaultItem: 'None',
    cameraPosition: undefined,
    price: 0,
    shopInfo: { quantity: 1 }
  }
};

const initialState: initialStateT = {
  configInfo: {
    isShortId: false,
  },
  modalState: {
    modalInfo: null,
    modalList: {
      arStep1: false,
      itemHint: false,
      MailComponent: false,
      MailSent: false,
      loader: false,
    },
  },
  attributes: mockInitialAttributes,
  priceInfo: priceId,
  priceAdditional: priceAdditional,
};

const Settings = (state: any = initialState, action: any) => {
  switch (action.type) {
    case TYPE_REDUCER.EXAMPLE_ACTION:
      return {
        ...state,
        example: action.payload,
      };
    case TYPE_REDUCER.SET_MODAL:
      return {
        ...state,
        modalState: {
          modalInfo: action.payload.info || null,
          modalList: {
            ...state.modalState.modalList,
            ...action.payload.list,
          },
        },
      };
    case TYPE_REDUCER.SET_ATTRIBUTES:
      return {
        ...state,
        attributes: action.payload,
      };
    case TYPE_REDUCER.SET_PRICE_INFO:
      return {
        ...state,
        priceInfo: action.payload,
      };
    case TYPE_REDUCER.SET_IS_SHORT_ID:
      return {
        ...state,
        configInfo: {
          ...state.modalState.configInfo,
          isShortId: action.payload,
        },
      };
    case TYPE_REDUCER.SET_ACTIVE_ITEM:
      const { name, data }: any = action.payload;
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [name]: {
            ...state.attributes[name],
            ...data,
          },
        },
      };
    default:
      return state;
  }
};
export default Settings;
